import type { ComponentType } from 'react';
import PersonOffOutlined from '@mui/icons-material/PersonOffOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import SendOutlined from '@mui/icons-material/SendOutlined';
import SupportAgentOutlined from '@mui/icons-material/SupportAgentOutlined';
import SnoozeOutlined from '@mui/icons-material/SnoozeOutlined';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { WorkflowStatusId } from 'types/workflow/workflow-status';

/** מטא לאייקונים וצבעי רקע לפי סטטוס — שימוש ברשימה ובסרגל המקוטע */
export const WORKFLOW_STATUS_UI: Array<{
  Icon: ComponentType<SvgIconProps>;
  cellBg: (t: Theme) => string;
  iconColor: (t: Theme) => string;
}> = [
  /** סטטוס 1 — «לשיוך לנציג»: כמו IconUserOff בתפריט הימני */
  {
    Icon: PersonOffOutlined,
    cellBg: (t) => alpha(t.palette.primary.main, 0.14),
    iconColor: (t) => (t.palette.mode === 'dark' ? t.palette.primary.light : t.palette.primary.dark),
  },
  {
    Icon: PersonOutlineOutlined,
    cellBg: (t) => alpha('#e57373', t.palette.mode === 'dark' ? 0.22 : 0.18),
    iconColor: (t) => (t.palette.mode === 'dark' ? '#ef9a9a' : '#c62828'),
  },
  {
    Icon: SendOutlined,
    cellBg: (t) => alpha(t.palette.grey[500], t.palette.mode === 'dark' ? 0.28 : 0.16),
    iconColor: (t) => (t.palette.mode === 'dark' ? t.palette.grey[300] : t.palette.grey[700]),
  },
  {
    Icon: SupportAgentOutlined,
    cellBg: (t) => alpha(t.palette.error.main, t.palette.mode === 'dark' ? 0.28 : 0.14),
    iconColor: (t) => (t.palette.mode === 'dark' ? t.palette.error.light : t.palette.error.dark),
  },
  {
    Icon: SnoozeOutlined,
    cellBg: (t) => alpha(t.palette.warning.main, t.palette.mode === 'dark' ? 0.25 : 0.16),
    iconColor: (t) => (t.palette.mode === 'dark' ? t.palette.warning.light : t.palette.warning.dark),
  },
  {
    Icon: FactCheckOutlined,
    cellBg: (t) => alpha(t.palette.success.main, t.palette.mode === 'dark' ? 0.22 : 0.14),
    iconColor: (t) => (t.palette.mode === 'dark' ? t.palette.success.light : t.palette.success.dark),
  },
];

export function workflowStatusMeta(status: WorkflowStatusId) {
  return WORKFLOW_STATUS_UI[status - 1];
}
